import * as types from '@/actions/types'

const initialState = {
  results: [],
  isSearching: false,
  resetResults: false,
  filters: '',
  resultVisible: false,
  currentGeolocation: [],
  currentPosition: [],
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_STORES:
      state = {
        ...state,
        results: action.stores,
      }
      break
    case types.SET_SEARCHING:
      state = {
        ...state,
        isSearching: action.isSearching,
      }
      break
    case types.SET_RESET_RESULT:
      state = {
        ...state,
        resetResults: action.reset,
      }
      break
    case types.SET_FILTERS:
      state = {
        ...state,
        filters: action.filters,
      }
      break
    case types.SET_RESULT_VISIBLE:
      state = {
        ...state,
        resultVisible: action.resultVisible,
      }
      break
    case types.RESET_STORES:
      state = {
        ...state,
        results: [],
        resultVisible: false,
      }
      break
    case types.SET_CURRENT_GEOLOCATION:
      state = {
        ...state,
        currentGeolocation: action.payload,
      }
      break
    case types.SET_CURRENT_POSITION:
      state = {
        ...state,
        currentPosition: action.payload,
      }
      break
    default:
      return { ...state }
  }
  return { ...state }
}

export default reducer
